import './BubbleBadge.scss';

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface BubbleBadgePropsBase {
  variant?:
    | 'slate'
    | 'smoke'
    | 'navy'
    | 'crimson'
    | 'grape'
    | 'ocean'
    | 'lime'
    | 'dirt'
    | 'ecru'
    | 'banana'
    | 'forest';
  color?: string;
  block?: boolean;
  circle?: boolean;
  inverse?: boolean;
  clickable?: boolean;
  showIcon?: boolean;
  allowBreaks?: boolean;
}

export type BubbleBadgeProps = React.HTMLAttributes<HTMLDivElement> & BubbleBadgePropsBase;

export default function BubbleBadge(props: BubbleBadgeProps) {
  const {
    // from component
    variant,
    color,
    block,
    circle,
    inverse,
    clickable,
    showIcon,
    allowBreaks,
    // from div
    className: propClasses,
    style: propStyle,
    children,
    ...rest
  } = props;

  const classes = ['bubble-badge'];
  if (variant) classes.push(variant);
  if (block) classes.push('full');
  if (circle) classes.push('circle');
  if (inverse) classes.push('inverse');
  if (clickable) classes.push('clickable');
  if (propClasses) classes.push(propClasses);

  let style: React.CSSProperties = {};
  if (color && !inverse) {
    style.backgroundColor = color;
    style.outlineColor = `${color}50`;
  }
  if (color && inverse) {
    style.color = color;
    style.borderColor = color;
    style.outlineColor = `${color}50`;
  }
  if (allowBreaks) {
    style.whiteSpace = 'break-spaces';
  } else {
    style.whiteSpace = 'nowrap';
  }

  if (propStyle) style = { ...style, ...propStyle };

  return (
    <div {...rest} className={classes.join(' ')} style={style}>
      {showIcon && <FontAwesomeIcon icon="xmark" className="mr-1" />}
      {children}
    </div>
  );
}
